export default __webpack_public_path__ + "static/media/news.81bea2fd.png";